/// <reference path="./externals.d.ts" />
var validator = require('./core/Validator');
var list = require('./core/List');
var utils = require('./core/Utils');
var accountHelper = require('./helpers/Account');
var blockedNumberHelper = require('./helpers/BlockedNumber');
var callHelper = require('./helpers/Call');
var contactHelper = require('./helpers/Contact');
var contactGroupHelper = require('./helpers/ContactGroup');
var conferencingHelper = require('./helpers/Conferencing');
var countryHelper = require('./helpers/Country');
var deviceHelper = require('./helpers/Device');
var deviceModelHelper = require('./helpers/DeviceModel');
var extensionHelper = require('./helpers/Extension');
var forwardingNumberHelper = require('./helpers/ForwardingNumber');
var languageHelper = require('./helpers/Language');
var locationHelper = require('./helpers/Location');
var messageHelper = require('./helpers/Message');
var phoneNumberHelper = require('./helpers/PhoneNumber');
var presenceHelper = require('./helpers/Presence');
var ringoutHelper = require('./helpers/Ringout');
var serviceHelper = require('./helpers/Service');
var shippingMethodHelper = require('./helpers/ShippingMethod');
var stateHelper = require('./helpers/State');
var timezoneHelper = require('./helpers/Timezone');
var RingCentralHelpers = (function () {
    function RingCentralHelpers() {
        this.version = '0.1.0';
        this._utils = new utils.Utils();
        this._validator = new validator.Validator(this._utils);
        this._list = new list.List(this._utils);
        this._account = new accountHelper.Account(this._utils, this._validator, this._list);
        this._blockedNumber = new blockedNumberHelper.BlockedNumber(this._utils, this._validator, this._list);
        this._conferencing = new conferencingHelper.Conferencing(this._utils, this._validator, this._list);
        this._contact = new contactHelper.Contact(this._utils, this._validator, this._list);
        this._contactGroup = new contactGroupHelper.ContactGroup(this._utils, this._validator, this._list);
        this._country = new countryHelper.Country(this._utils, this._validator, this._list);
        this._extension = new extensionHelper.Extension(this._utils, this._validator, this._list);
        this._deviceModel = new deviceModelHelper.DeviceModel(this._utils, this._validator, this._list);
        this._device = new deviceHelper.Device(this._utils, this._validator, this._list, this._extension, this._deviceModel);
        this._presence = new presenceHelper.Presence(this._utils, this._validator, this._list, this._extension);
        this._call = new callHelper.Call(this._utils, this._validator, this._list, this._presence, this._contact);
        this._forwardingNumber = new forwardingNumberHelper.ForwardingNumber(this._utils, this._validator, this._list);
        this._language = new languageHelper.Language(this._utils, this._validator, this._list);
        this._state = new stateHelper.State(this._utils, this._validator, this._list, this._country);
        this._location = new locationHelper.Location(this._utils, this._validator, this._list, this._state);
        this._message = new messageHelper.Message(this._utils, this._validator, this._list, this._contact);
        this._phoneNumber = new phoneNumberHelper.PhoneNumber(this._utils, this._validator, this._list);
        this._ringout = new ringoutHelper.Ringout(this._utils, this._validator, this._list);
        this._service = new serviceHelper.Service(this._utils, this._validator, this._list);
        this._shippingMethod = new shippingMethodHelper.ShippingMethod(this._utils, this._validator, this._list);
        this._timezone = new timezoneHelper.Timezone(this._utils, this._validator, this._list);
    }
    RingCentralHelpers.prototype.country = function () { return this._country; };
    RingCentralHelpers.prototype.deviceModel = function () { return this._deviceModel; };
    RingCentralHelpers.prototype.language = function () { return this._language; };
    RingCentralHelpers.prototype.location = function () { return this._location; };
    RingCentralHelpers.prototype.shippingMethod = function () { return this._shippingMethod; };
    RingCentralHelpers.prototype.state = function () { return this._state; };
    RingCentralHelpers.prototype.timezone = function () { return this._timezone; };
    RingCentralHelpers.prototype.account = function () { return this._account; };
    RingCentralHelpers.prototype.blockedNumber = function () { return this._blockedNumber; };
    RingCentralHelpers.prototype.call = function () { return this._call; };
    RingCentralHelpers.prototype.conferencing = function () { return this._conferencing; };
    RingCentralHelpers.prototype.contact = function () { return this._contact; };
    RingCentralHelpers.prototype.contactGroup = function () { return this._contactGroup; };
    RingCentralHelpers.prototype.device = function () { return this._device; };
    RingCentralHelpers.prototype.extension = function () { return this._extension; };
    RingCentralHelpers.prototype.forwardingNumber = function () { return this._forwardingNumber; };
    RingCentralHelpers.prototype.message = function () { return this._message; };
    RingCentralHelpers.prototype.phoneNumber = function () { return this._phoneNumber; };
    RingCentralHelpers.prototype.presence = function () { return this._presence; };
    RingCentralHelpers.prototype.ringout = function () { return this._ringout; };
    RingCentralHelpers.prototype.service = function () { return this._service; };
    return RingCentralHelpers;
})();
module.exports = new RingCentralHelpers();



/*****************
 ** WEBPACK FOOTER
 ** ./src/SDK.ts
 ** module id = 1
 ** module chunks = 0
 **/